export const TYPE_LABEL_MAP = {
  text: 'String',
  number: 'Number',
  boolean: 'Boolean',
  date: 'Date',
  email: 'Email',
  url: 'URL',
  tel: 'Phone Number',
  large_text: 'Large Text',
  static_option: 'Static Option',
};

export const FIELD_TYPE_OPTIONS = [
  { label: 'String', value: 'text' },
  { label: 'Number', value: 'number' },
  { label: 'Boolean', value: 'boolean' },
  { label: 'Date', value: 'date' },
  { label: 'Email', value: 'email' },
  { label: 'URL', value: 'url' },
  { label: 'Phone Number', value: 'tel' },
  { label: 'Large Text', value: 'large_text' },
  { label: 'Static Option', value: 'static_option' },
];

export const BASE_AI_MODELS = [
  { label: 'Open AI', value: 'OPEN_AI' },
  { label: 'Anthropic AI', value: 'CLAUDE_AI' },
  { label: 'DeepSeek AI', value: 'DEEPSEEK_AI' },
];

export const createRedirectUrl = () => {
  let domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}/`;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  if (environment === 'DEV') {
    redirectUrl = `http://${domainName}:9075/`;
  } else if (environment === 'STAGING') {
    domainName = domainName.replace('builder.webkonnect.digital', 'builderc.webkonnect.digital');
    redirectUrl = `https://${domainName}/`;
  } else {
    domainName = domainName.replace('builder.mydrapcode.com', 'builderc.mydrapcode.com');
    redirectUrl = `https://${domainName}/`;
  }
  return redirectUrl;
};